
const ImageEvent: React.FC<{ imagePath: string }> = (props) => {
    
    const handleClick = () => {
        const modal = document.querySelector("#modal-general") as HTMLDivElement;
        const modalContent = document.querySelector("#modal-general-content") as HTMLDivElement;

        const newChild = document.createElement("img");
        newChild.setAttribute("src", props.imagePath);
        newChild.setAttribute("id", "modal-img");
        modalContent.appendChild(newChild);
        modal.setAttribute("class", "modal-backdrop isDisplayed");
    }

    return (
        <div className="container-image-event" style={{ cursor: "pointer" }} onClick={handleClick}>
            {props.children}
        </div>
    );
}

export default ImageEvent;